import React from "react";
import './footer.css'
import { BsLinkedin, BsGithub } from 'react-icons/bs'

const Footer = () => {
    return (
        <footer>
            <a href="#" className="footer__logo mono">~/sumit-kumar</a>
            <ul className="permalinks">
                <li><a href="#">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#experience">Skills</a></li>
                <li><a href="#portfolio">Work</a></li>
                <li><a href="#side-projects">Side Projects</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>
            <div className="footer__socials">
                <a href="https://linkedin.com/in/rsumit123" target="_blank" rel="noreferrer"><BsLinkedin/></a>
                <a href="https://github.com/rsumit123" target="_blank" rel="noreferrer"><BsGithub/></a>
            </div>
            <div className="footer__copyright mono">
                <small>
                    <span className="txt-green">$</span> exit &nbsp;
                    <span className="txt-muted">&copy; {new Date().getFullYear()} Sumit Kumar</span>
                    <span className="footer__cursor"></span>
                </small>
            </div>
        </footer>
    )
}

export default Footer
